export class Funciones {

    constructor() { }
    /**
     * Rellena los espacios a la izquierda de la longitud deseada con la cadena
     * de rellono enviada
     * 
     * @author Eder Ruíz
     * @fecha 09/09/2022
     * 
     * @param cadenaOriginal string original
     * @param cadenaRelleno string de rellena
     * @param longitud numero de veces que se repetirá la cadena relleno
     * @returns cadena final
     */
    static async LPAD(cadenaOriginal: string, cadenaRelleno: string, longitud: number): Promise<string> {
        switch (cadenaOriginal.length) {
            case 1:
                longitud = longitud;
                break;
            case 2:
                longitud -= 1;
                break;
            case 3:
                longitud -= 2;
                break;
            case 4:
                longitud -= 3;
                break;
            default:
                break;
        }
        return `${cadenaRelleno.repeat(longitud)}${cadenaOriginal}`;
    }

    /**
     * Función que redondea un calculo
     * 
     * <b>Autor: </b> Aldair Cruz
     * <b>Fecha de Creación: </b> 12/03/2022
     * 
     * @param {double} importe importe que será redondeado
     * @param {int} decimales Limite de Decimales a las cuales se redondeara
     * @returns regresa el impoorte redondeado
     */
    static round(importe:number, decimales: number) {
        importe = Number(importe);
        return Number(importe.toFixed(decimales));
    }

    static totalCampo(array: any[], key: string, redondeo_decimales: number) {
        return Funciones.round(array.map(item => item[key]).reduce((valor_anterior, valor_actual) => valor_anterior + valor_actual, 0), redondeo_decimales);
    }

    /**
     * Convierte el Numero Recibido en un formato de moneda
     * 
     * @param {double} importe 
     */
    static getMoneda(importe: number) {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2 })
            .format(importe)
            .replace('MX', '');
    }

    /**
     * Convierte el Numero Recibido en un formato de porcentaje
     * 
     * @param {double} importe 
     * @return retornara el importe en formato porcentaje <br>
     * ej. si importe es 1000 retornara $ 1,000.00 ej. si importe es 3.14151618
     * retornara 3.14%
     */
    static getPorcentaje(importe: number) {
        return new Intl.NumberFormat('en-US', {
            style: 'percent',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(importe);
    }


    /**
     * Devuelve una copia profunda de cualquier tipo de objeto o dato.
     * @param {any} objeto 
     * @returns 
     */
    static copiaProfunda(objeto : any ) : unknown{

        const json_objeto = JSON.stringify(objeto)
        const copy = JSON.parse(json_objeto)
        return copy;

    }

}